module.exports = __webpack_public_path__ + "static/media/volunteers-opportunities.dfd8f93a.svg";